<rask-header [uppercase]="true">
    {{ 'ADMINISTRATION_ARBETSORDER' | translate}}
</rask-header>
<rask-container-block>
    <ng-container header>{{ 'ADMINISTRATION_ARBETSORDER_DISTRIKT_HEADER' | translate}}</ng-container>
    <rask-response-panel
        [show]="arbetsorderDistriktResponse"
        label="Resultat ({{arbetsorderDistriktResponse}})"
        [message]="'ADMINISTRATION_ARBETSORDER_DISTRIKT_SUCCESS' | translate"></rask-response-panel>
    <ng-container footer>
        <rask-button color="secondary" (click)="arbetsorderDistriktOmkorning()">
            {{ 'DEFAULT_BUTTON_LABEL_OMKORNING' | translate}}</rask-button>
    </ng-container>
</rask-container-block>

<rask-container-block>
    <ng-container header>Köa upp aktiva arbetsordrar för synkronisering av avverkningsdirektiv</ng-container>
    <rask-input label="Begränsning antal" [(ngModel)]="avverkningsdirektivLimit"></rask-input>
    <ng-container footer>
        <rask-button color="secondary" (click)="enqueueActiveAvverkningsdirektivCommand(avverkningsdirektivLimit)">Köa
            upp</rask-button>
    </ng-container>
</rask-container-block>

<rask-container-block>
    <ng-container header>Köa upp aktiva arbetsordrar för synkronisering av avverkningsdirektiv</ng-container>
    <rask-textarea [rows]="5" style="width: 100%;" label="Beteckning (AA1111, AB1234, ...)"
        [(ngModel)]="avverkningsdirektivBeteckningar"></rask-textarea>
    <ng-container footer>
        <rask-button color="secondary" (click)="enqueueAvverkningsdirektiv(avverkningsdirektivBeteckningar)">Köa upp
        </rask-button>
    </ng-container>
</rask-container-block>

<rask-container-block>
    <ng-container header>Seeda virkesordernummerserie</ng-container>
    <rask-input label="Huvudkod" [(ngModel)]="huvudkod">
    </rask-input>
    <rask-input label="Start" [(ngModel)]="start">
    </rask-input>
    <rask-input label="Slut" [(ngModel)]="slut">
    </rask-input>
    <ng-container footer>
        <rask-button color="secondary" (click)="seedVirkesordernummer(huvudkod, start, slut)">Starta</rask-button>
    </ng-container>
</rask-container-block>

<rask-container-block>
    <ng-container header>Kör om beräkning av aggregerad ArbetsorderVolym</ng-container>
    <rask-textarea [rows]="5" style="width: 100%;" label="Arbetsorder-GUID:ar (komma-separerade)"
        [(ngModel)]="recalcArbetsorderGUIDs"></rask-textarea>
    <ng-container footer>
        <rask-button color="secondary" (click)="rerunRecalculateArbetsorderVolymer(recalcArbetsorderGUIDs)">Starta
        </rask-button>
    </ng-container>
</rask-container-block>

<rask-container-block>
    <ng-container header>Räkna om direktutbyte för enskild arbetsorder</ng-container>
    <rask-input label="Arbetsorderbeteckning" [(ngModel)]="arbetsorderBeteckningDirektutbyte"></rask-input>

    <ng-container footer>
        <rask-button color="secondary" (click)="recalculateDirektutbyte()">Starta</rask-button>
    </ng-container>
</rask-container-block>
<rask-container-block>
    <ng-container header>Lägg till Centrala virkesköps rader i regelverk</ng-container>
    <ng-container footer>
        <rask-button color="secondary" (click)="addRegelverkCentralaVirkeskop()">Starta</rask-button>
    </ng-container>
</rask-container-block>

<rask-container-block>
    <ng-container header>Utbytessimulera Arbetsorder</ng-container>
    <ng-container footer>
        <rask-input-number label="Arbetsorder id:"  [(ngModel)]="arbetsorderAttSimuleraId"></rask-input-number>
        <rask-button color="secondary" (click)="utbyteSimuleraArbetsorder()">Simulera</rask-button>
    </ng-container>
</rask-container-block>
